import { Component, OnInit } from '@angular/core';
import { MatDialog } from "@angular/material/dialog";
import { Router } from '@angular/router';
import { LoginService } from 'src/app/services/login.service';


import {PerfilClienteComponent} from "../../portal-cliente/perfil/perfil-cliente/perfil-cliente.component"
import {PerfilContratistaComponent} from "../../portal-contratista/perfil/perfil-contratista/perfil-contratista.component"


@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss']
})
export class UserComponent implements OnInit {

  public path: any;
  public userLogged: any
  constructor(public dialog: MatDialog, private router: Router, private loginService: LoginService) {
    this.path = this.router.url
    this.userLogged = loginService.getUserData()
   }

  ngOnInit(): void {
  }

  openDialogCliente() {
    this.dialog.open(PerfilClienteComponent);
  }
  openDialogContra() {
    this.dialog.open(PerfilContratistaComponent);
  }
 

}
